import { createFileRoute } from "@tanstack/react-router";
import { optionalLiteralParam, parseableSearchSchema } from "@crm/effect/schema/search";
import { Schema } from "effect";

const regularCareSearchSchema = parseableSearchSchema(
  Schema.Struct({
    status: optionalLiteralParam("all", "cared", "lost", "normal"),
  }),
);

export const Route = createFileRoute("/_protected/dashboard/metrics/_details/regular-care/")({
  validateSearch: regularCareSearchSchema,
  pendingMinMs: 200
});
